<template>
   <span @click.stop="onClick">
      <template v-if="isShowAll">{{ phone }}</template>
      <template v-else>{{ phone | phone }}</template>
      <i class="el-icon-copy-document" @click.stop="onCopy()" style="margin-left: 5px;"></i>
   </span>
</template>

<script>
import { copyLayoutParams } from 'echarts/lib/util/layout';

export default {
   props: {
      phone: {
         type: String,
         default: "",
      },
   },
   data() {
      return {
         isShowAll: false,
      };
   },
   methods: {
      onClick() {
         this.isShowAll = !this.isShowAll;
      },
      onCopy() {
         const input = document.createElement("input");
         document.body.appendChild(input);
         input.value = this.phone;
         input.select();
         document.execCommand("copy");
         document.body.removeChild(input);
         this.$message.success("复制成功");
      }
   },
};
</script>

<style scoped lang="scss">
span {
   cursor: pointer;
}
</style>
